"use client";

import story480 from "@/assets/story-workshop-480.webp";
import story768 from "@/assets/story-workshop-768.webp";
import story960 from "@/assets/story-workshop-960.webp";
import { Cta } from "./cta";
import { MaskedHeadline, Parallax, Reveal } from "./motion-primitives";
import { useQuote } from "./quote-context";
import { ResponsiveImage, srcSet } from "./responsive-image";

export function Story() {
  const { goToQuote } = useQuote();
  return (
    <section id="story" className="bg-ivory py-24 sm:py-32">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20">
        <Parallax className="aspect-[7/6] w-full" amount={30}>
          <ResponsiveImage
            src={story480}
            srcSet={srcSet([
              [story480, 480],
              [story768, 768],
              [story960, 960],
            ])}
            sizes="(min-width: 1024px) 50vw, 100vw"
            alt="Collection of custom laser-engraved leather patches in different shapes and logos"
            width={960}
            height={922}
            className="size-full scale-110 object-cover"
          />
        </Parallax>

        <div>
          <p className="eyebrow text-brass-deep">Our story</p>
          <h2 className="mt-5 font-display text-[clamp(2rem,4.5vw,3.5rem)] leading-[0.98] font-bold text-ink">
            <MaskedHeadline lines={["Built on personal service,", "quality, and communication."]} />
          </h2>
          <Reveal delay={0.12}>
            <p className="mt-7 max-w-lg text-base leading-relaxed text-muted-foreground">
              Founded in 2019, Mills Engraving is a family-owned business based in
              Stockton, Manitoba. Every inquiry is treated as a real conversation—because
              choosing the right product and creating the right result should feel
              personal from the beginning.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9">
              <Cta variant="outline" onClick={() => goToQuote()}>
                Meet Mills Engraving
              </Cta>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}